import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      name: ROUTE_NAMES.INSIGHTS.INDEX,
      component: () => import('~/scopes/insights/pages/Insights.vue'),
      path: '/bo-seller/insights',
      meta: {
        autonomousBannerPageName: 'insights',
        owners: ['bot-squad-seller-experience-front'],
      },
    },
  ]
}

export default routes
